import * as Level from '.';
import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';

export const levelActions = createActions({
  claimLevelRewards: action((state, _, api) => {
    Level.modifiers.claimLevelRewards(state, api);
  }),
});
